module.exports = __webpack_public_path__ + "static/media/bioteque-logo-new-white.9d40fc33.png";